

<template>
  <v-app id="vapp">
    <!--version 0.9.02-->
    <!--//@*/*
        //    *RPD  Appv0.91
        //    * Copyright (c) 2022, Blue Cover Six LLC . All rights reserved.
        //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
        //    */
        //-->
    <auth></auth>
    <v-overlay opacity="0.97" :z-index="zIndex" :value="overlay">
      <v-progress-circular
        :size="50"
        style="z-index: 5200"
        color="deep-orange accent-2"
        indeterminate
      >
      </v-progress-circular>
    </v-overlay>

    <!--<brandbar></brandbar>-->
    <v-main id="main">
      <Transition name="fade-transition" mode="out-in">
        <router-view :key="$route.fullPath" />
      </Transition>
    </v-main>
  </v-app>
</template>

<style>
.v-main {
  padding: 5px 0 0 0 !important;
}

#vapp {
  background-color: var(--v-background-base);
  overflow-y: auto;
  max-height: 100vh;
  height: 100vh;
  overflow-x: hidden;
}

@supports (max-height: 100dvh) {
  #vapp {
    max-height: 100dvh !important;
  }
}

.swal2-popup {
  /* font-size: 1.15rem !important;*/
  font-family: "Roboto", sans-serif !important;
}

@media only screen and (min-width: 769px) {
  ::-webkit-scrollbar {
    width: 12px;
    height: 12px;
  }

  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    background: rgba(230, 230, 230, 1);
  }

  ::-webkit-scrollbar-thumb {
    border: 1px solid grey;
    border-radius: 4px;
    background: var(--v-backdrop-lighten2);
    -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.8);
  }

  ::-webkit-scrollbar-thumb:hover {
    background: var(--v-backdrop-lighten1);
  }
}

@media only screen and (max-width: 800px) {
  .v-main {
    padding: 0px !important;
  }

  .v-application--is-ltr .v-stepper--vertical .v-stepper__content {
    margin: -8px -36px -16px 19px !important;
  }

  .v-stepper--vertical .v-stepper__step {
    padding: 24px 8px 16px !important;
  }

  .v-navigation-drawer__content {
    height: 87% !important;
  }

  .patrol-type-button .v-btn__content {
    white-space: normal !important;
  }
}

.v-application--is-ltr .v-text-field .v-input__prepend-inner {
  margin-top: 8px !important;
  padding-right: 6px !important;
}

.v-input--radio-group.v-input--radio-group--row .v-radio {
  margin-bottom: 5px;
}

.sign-image {
  /*border: 1px solid black;*/
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

.v-btn--active.no-active::before {
  opacity: 0 !important;
}

.v-btn--active.no-active:not(:hover)::before {
  opacity: 0 !important;
}

.v-data-table__expanded__content {
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px !important;
}

input {
  color-scheme: dark;
}

.v-application--is-ltr .v-data-footer__select {
  margin-right: 0px !important;
}

.v-application--is-ltr .v-data-footer__select .v-select {
  margin: 9px 0 11px 15px !important;
}

.v-btn__content {
  text-wrap: wrap;
  max-width: fit-content;
}

.theme--dark.v-stepper .v-stepper__step__step {
  color: black !important;
}

.v-stepper__step__step .v-icon.v-icon {
  color: black !important;
}

.theme--dark.v-stepper {
  background: var(--v-backdrop-lighten1) !important;
}

.v-stepper__header {
  padding: 15px;
}

.v-expansion-panel,
.v-expansion-panel-header,
.v-expansion-panel-content {
  transition: 0.1s cubic-bezier(0.25, 0.8, 0.5, 1) !important;
}

.faded-card-text {
  color: rgba(255, 255, 255, 0.7);
}
</style>

<script>
import { bus_common } from "../mixins/bus_common";
import auth from "./auth.vue";
export default {
  name: "App",
  mixins: [bus_common],
  components: { auth },
  data() {
    return {
      zIndex: 4000,
    };
  },

  computed: {
    overlay: function () {
      return this.$store.state.loader_visible;
    },
  },
  methods: {
    logout() {
      this.swall_diag(
        "Log Out?",
        "Are you sure you would like to log out?",
        "question",
        null,
        "Yes",
        "No",
        null,
        null
      );
    },
    async getDivisions() {
      let callback = () => {
        window.location.replace(this.$store.state.loginURL);
      };
      var form = { token: this.$store.state.user.token };

      await this.$axios
        .post("/api/division/GetAll", form)
        .then((response) => {
          this.$store.commit("setlogDivisions", response.data);
        })
        .catch((error) => {
          this.hande_swal_error(error, null);
        });
    },
  },
  created() {},
  watch: {
    "$store.state.user.token": function () {
      if (this.$store.state.user.token != "") {
        this.getDivisions();
      }
    },
  },
};
</script>

